import type { CustomerEntity } from '../payment'
import type {
  InflatedCartDto,
} from './schemas'
import { initContract } from '@ts-rest/core'
import z from 'zod'
import { Brand, ErrorResponseSchema, HistoryTables } from '../../shared'
import { CatDtoSchema, UpdateCatBodySchema } from '../animal'
import { FeedingPlanType } from '../common'
import { GetBoxesByOrderResponseSchema } from '../fulfilment'
import { AddressState, DeliverySlotWindow, JobStatus, UpdateOrderLineItemSchema } from '../order'
import { OrderResponseSchema } from '../order/schemas'
import { FeedingPlanServingSize } from '../subscription'
import {
  SubscriptionSchema,
  UpdateSubscriptionBodyExtraSchema,
  UpdateSubscriptionBodyFeedingPlanSkuSchema,
} from '../subscription/schemas'
import {
  AddAnimalToSubscriptionInputSchema,
  AddAnimalToSubscriptionResultSchema,
  AddCatToSubscriptionInputSchema,
  AddCatToSubscriptionPreviewOutputSchema,
  AddDogToSubscriptionInputSchema,
  AddDogToSubscriptionOutputSchema,
  AddDogToSubscriptionPreviewOutputSchema,
  AddOneOffExtraInputSchema,
  AddressInputSchema,
  AddSubscriptionExtraInputSchema,
  ApplyOrderDiscountInputSchema,
  ApplyOrderDiscountOutputSchema,
  ApplyOrderDiscountPreviewInputSchema,
  ApplyOrderDiscountPreviewOutputSchema,
  ApplyPromotionToCartInputSchema,
  ApplyPromotionToCartResultSchema,
  ApplyReferrerRewardInputSchema,
  ApplyReferrerRewardOutputSchema,
  ApplySubscriptionDiscountInput,
  ApplySubscriptionDiscountPreviewInputSchema,
  ApplySubscriptionDiscountPreviewResultSchema,
  ApplySubscriptionDiscountResult,
  BackfillOrderAnimalServingsInputSchema,
  BackfillOrderAnimalServingsOutputSchema,
  BackfillOrderLineItemProductTypeInputSchema,
  BackfillOrderLineItemProductTypeOutputSchema,
  BackfillOrderPricingInputSchema,
  BackfillOrderPricingOutputSchema,
  BackfillOrderSubscriptionHistoryInputSchema,
  BackfillOrderSubscriptionHistoryOutputSchema,
  ConsolidateMigratedOrderSubscriptionsInputSchema,
  ConsolidateMigratedOrderSubscriptionsOutputSchema,
  ConsolidatePhoenixOrderSubscriptionsInputSchema,
  ConsolidatePhoenixOrderSubscriptionsOutputSchema,
  BackfillFeedingPlanHistoryIdsInputSchema,
  BackfillFeedingPlanHistoryIdsOutputSchema,
  BackfillOrderCutoffsInputSchema,
  BackfillOrderCutoffsOutputSchema,
  BackfillMealPlanSnapshotsInputSchema,
  BackfillMealPlanSnapshotsOutputSchema,
  BackfillFulfilmentCustomerIdsInputSchema,
  BackfillFulfilmentCustomerIdsOutputSchema,
  BulkMigrateDataFromLaravelToPhoenixInputSchema,
  BulkMigrateDataFromLaravelToPhoenixOutputSchema,
  BulkMigrateDataFromLaravelToPhoenixV2InputSchema,
  BulkMigrateHistoryDataFromLaravelToPhoenixInputSchema,
  BulkMigrateRafCouponsInputSchema,
  BulkMigrateRafCouponsOutputSchema,
  LaunchRafCampaignInputSchema,
  LaunchRafCampaignOutputSchema,
  BulkMigrateRafCouponUsersInputSchema,
  BulkMigrateRafCouponUsersOutputSchema,
  BulkMigrateUserEventDataFromLaravelToPhoenixInputSchema,
  CancelSubscriptionInputSchema,
  CancelSubscriptionResultSchema,
  CheckCouponExistsInputSchema,
  CheckCouponExistsOutputSchema,
  CheckSubscriptionValidityInputSchema,
  CheckSubscriptionValidityOutputSchema,
  CreateAccountScenarioInputSchema,
  CreateTestAccountInputSchema,
  CreateTestAccountResultSchema,
  CreateTygaAccountForExistingUserInputSchema,
  CreateTygaTestAccountInputSchema,
  DeleteOneOffExtraInputSchema,
  DeleteSubscriptionExtraInputSchema,
  DuplicateOrderInputSchema,
  DuplicateOrderOutputSchema,
  GenerateFutureOrderInputSchema,
  GetEnrichedUserEventsInputSchema,
  GetEnrichedUserEventsOutputSchema,
  GetOrderAllowedFreePouchVariantsInputSchema,
  GetOrderAllowedFreePouchVariantsOutputSchema,
  GetPuppyMilestonesInputSchema,
  GetPuppyMilestonesOutputSchema,
  GraduatePuppyInputSchema,
  GraduatePuppyOutputSchema,
  LykaCheckoutInputSchema,
  LykaCheckoutResultSchema,
  ManualChargeOrderInputSchema,
  ManualChargeOrderResultSchema,
  MigrateBaBCustomerFromLaravelToPhoenixInputSchema,
  MigrateBaBCustomerFromLaravelToPhoenixOutputSchema,
  MigrateDataFromLaravelToPhoenixInputSchema,
  MigrateDataFromLaravelToPhoenixOutputSchema,
  MigrateDataFromLaravelToPhoenixQuerySchema,
  MigrateGeneralOutputSchema,
  MigrateHistoryDataFromLaravelToPhoenixInputSchema,
  MigrateHistoryDataFromLaravelToPhoenixOutputSchema,
  MigrateUserEventDataFromLaravelToPhoenixInputSchema,
  MoveSubscriptionExtraInputSchema,
  MoveRebalanceOrdersInputSchema,
  MoveRebalanceOrdersAsyncStartResponseSchema,
  WorkflowStatusResponseSchema,
  PauseSubscriptionInputSchema,
  PauseSubscriptionResultSchema,
  PostPaymentOrderModifiedSchema,
  PricedAnimalPlanInputSchema,
  PricedAnimalPlanSchema,
  ReactivateCatFromSubscriptionInputSchema,
  ReactivateCatFromSubscriptionPreviewOutputSchema,
  ReactivateDogFromSubscriptionInputSchema,
  ReactivateDogFromSubscriptionOutputSchema,
  ReactivateDogFromSubscriptionPreviewOutputSchema,
  ReactivateSubscriptionInputSchema,
  RecalculateDogMealPlanSubscriptionInputSchema,
  RecalculateDogMealPlanSubscriptionOutputSchema,
  NetsuiteSyncSummaryInputSchema,
  NetsuiteSyncSummaryOutputSchema,
  ReconcilePhoenixToggleInputSchema,
  ReconcilePhoenixToggleOutputSchema,
  RemoveCatFromSubscriptionInputSchema,
  RemoveCatFromSubscriptionOutputSchema,
  RemoveCatFromSubscriptionPreviewOutputSchema,
  RemoveDogFromSubscriptionInputSchema,
  DeleteOrderComplaintInputSchema,
  DeleteOrderComplaintOutputSchema,
  CreateOrderComplaintWorkflowInputSchema,
  CreateOrderComplaintWorkflowOutputSchema,
  UpdateOrderComplaintWorkflowInputSchema,
  UpdateOrderComplaintWorkflowOutputSchema,
  RemoveDogFromSubscriptionOutputSchema,
  RemoveDogFromSubscriptionPreviewOutputSchema,
  RemoveOrderDiscountInputSchema,
  RemoveOrderDiscountOutputSchema,
  RemoveSubscriptionDiscountInputSchema,
  RemoveSubscriptionDiscountResultSchema,
  RescheduleBlockedOrdersInputSchema,
  RescheduleBlockedOrdersOutputSchema,
  RestructureOrdersInputSchema,
  ResumeSubscriptionInputSchema,
  RevertMigrateUserEventSchema,
  ReviewUpdateSubscriptionPayloadSchema,
  RedistributeSubscriptionMealInputSchema,
  RedistributeSubscriptionMealOutputSchema,
  SanitizeSubscriptionInputSchema,
  SanitizeSubscriptionOutputSchema,
  SeedFulfilmentDataInputSchema,
  SeedFulfilmentDataOutputSchema,
  SendPublicHolidayNotificationsAsyncStartResponseSchema,
  SendPublicHolidayNotificationsInputSchema,
  TygaCheckoutInputSchema,
  TygaCheckoutResultSchema,
  UpdateCatSubscriptionPlanInputSchema,
  UpdateCatSubscriptionPlanOutputSchema,
  UpdateCatSubscriptionPlanPreviewOutputSchema,
  UpdateDogProfileInputSchema,
  UpdateDogProfileResultSchema,
  UpdateDogSubscriptionActiveFeedingPlansInputSchema,
  UpdateDogSubscriptionActiveFeedingPlansOutputSchema,
  UpdateDogSubscriptionActiveFeedingPlansPreviewOutputSchema,
  UpdateOneOffExtraInputSchema,
  UpdateOrderExtrasInputSchema,
  UpdateOrderExtrasPreviewInputSchema,
  UpdateOrderExtrasPreviewOutputSchema,
  UpdateRafCouponInputSchema,
  UpdateRafCouponOutputSchema,
  UpdateSubscriptionExtraInputSchema,
  UpdateSubscriptionExtrasInputSchema,
  UpdateSubscriptionExtrasOutputSchema,
  UpdateSubscriptionExtrasPreviewOutputSchema,
  UpdateSubscriptionPriceVersionInput,
  UpdateSubscriptionPriceVersionOutput,
  UpsertNetsuiteCustomerInputSchema,
  UpsertNetsuiteCustomerOutputSchema,
  VerificationResponseSchema,
  VerifySubscriptionOrdersSchema,
  BackfillStarterBoxFeedingPlanInputSchema,
  BackfillStarterBoxFeedingPlanOutputSchema,
  RepairOrderUserIdsInputSchema,
  RepairOrderUserIdsOutputSchema,
} from './schemas'
import { partnersRoutes } from './partners.contract'

const options = {
  commonResponses: {
    400: ErrorResponseSchema,
    500: ErrorResponseSchema,
    404: ErrorResponseSchema,
  },
}

const c = initContract()

/**
 * Routes are split into multiple groups (A, B, C...) to avoid TS7056 ("inferred type exceeds
 * maximum serialisable length"). Each group is small enough for TypeScript
 * to emit its declaration individually, and the exported contract is typed
 * via an intersection alias that references them by name.
 */
export const orchestrationRoutesA = c.router(
  {
    getHealth: {
      method: 'GET',
      path: '/health',
      summary: 'Health check endpoint',
      description: 'Checks if the service is healthy',
      responses: {
        200: z.object({
          status: z.string(),
        }),
      },
    },
    resetSchedules: {
      method: 'POST',
      path: '/workflows/reset-temporal-schedules',
      summary: 'Reset schedules in temporal',
      description: 'Reset schedules in temporal',
      body: z.object({
        skipCleanup: z.boolean().default(false).optional(),
      }),
      responses: {
        200: z.object({
          success: z.boolean(),
        }),
      },
    },
    getWorkflowStatus: {
      method: 'GET',
      path: '/workflows/:workflowId/status',
      pathParams: z.object({
        workflowId: z.string(),
      }),
      summary: 'Get status of a Temporal workflow by id',
      responses: {
        200: WorkflowStatusResponseSchema,
      },
    },
    // TODO Deprecated - to be removed after confirming no usage from lyka-account
    updateSubscriptionTreats: {
      method: 'POST',
      path: '/workflows/update-subscription-treats',
      deprecated: true,
      body: z.object({
        workflowId: z.string().optional(),
        input: z.array(UpdateSubscriptionBodyExtraSchema),
        subscriptionId: z.string(),
      }),
      responses: {
        200: SubscriptionSchema,
      },
    },
    reviewUpdateSubscriptionFeedingPlanType: {
      method: 'POST',
      path: '/workflows/review-update-subscription-feeding-plan-type',
      body: z.object({
        workflowId: z.string().optional(),
        subscriptionId: z.string(),
        feedingPlanType: z.nativeEnum(FeedingPlanType),
      }),
      responses: {
        200: ReviewUpdateSubscriptionPayloadSchema,
      },
    },
    updateSubscriptionFeedingPlanType: {
      method: 'POST',
      path: '/workflows/update-subscription-feeding-plan-type',
      body: z.object({
        workflowId: z.string().optional(),
        subscriptionId: z.string(),
        feedingPlanType: z.nativeEnum(FeedingPlanType),
      }),
      responses: {
        200: SubscriptionSchema,
      },
    },
    updateSubscriptionRecipeMix: {
      method: 'POST',
      path: '/workflows/update-subscription-recipe-mix',
      body: z.object({
        brand: z.nativeEnum(Brand).default(Brand.LYKA),
        workflowId: z.string().optional(),
        feedingPlanId: z.string(),
        subscriptionId: z.string(),
        recipeMix: z.array(UpdateSubscriptionBodyFeedingPlanSkuSchema),
      }),
      responses: {
        200: SubscriptionSchema,
      },
    },
    reviewUpdateSubscriptionServingSize: {
      method: 'POST',
      path: '/workflows/review-update-subscription-serving-size',
      body: z.object({
        workflowId: z.string().optional(),
        feedingPlanId: z.string(),
        subscriptionId: z.string(),
        servingSize: z.nativeEnum(FeedingPlanServingSize),
      }),
      responses: {
        200: ReviewUpdateSubscriptionPayloadSchema,
      },
    },
    updateSubscriptionServingSize: {
      method: 'POST',
      path: '/workflows/update-subscription-serving-size',
      body: z.object({
        workflowId: z.string().optional(),
        feedingPlanId: z.string(),
        subscriptionId: z.string(),
        servingSize: z.nativeEnum(FeedingPlanServingSize),
      }),
      responses: {
        200: SubscriptionSchema,
      },
    },
    updateSubscriptionPriceVersion: {
      method: 'POST',
      path: '/workflows/update-subscription-price-version',
      body: UpdateSubscriptionPriceVersionInput,
      responses: {
        200: UpdateSubscriptionPriceVersionOutput,
      },
    },
    updateOrderExtras: {
      method: 'POST',
      path: '/workflows/update-order-extras',
      body: UpdateOrderExtrasInputSchema,
      responses: {
        200: OrderResponseSchema,
      },
    },
    updateOrderRecipeMix: {
      method: 'POST',
      path: '/workflows/update-order-recipe-mix',
      body: z.object({
        workflowId: z.string().optional(),
        orderId: z.string(),
        input: z.array(UpdateOrderLineItemSchema),
      }),
      responses: {
        200: OrderResponseSchema,
      },
    },
    updateOrderDeliveryDate: {
      method: 'POST',
      path: '/workflows/update-order-delivery-date',
      body: z.object({
        workflowId: z.string().optional(),
        orderId: z.string(),
        deliveryDate: z
          .string()
          .regex(/^\d{4}-\d{2}-\d{2}$/, 'Invalid date format. Expected "YYYY-MM-DD".'),
      }),
      responses: {
        200: z.array(OrderResponseSchema),
      },
    },
    moveRebalanceOrders: {
      method: 'POST',
      path: '/workflows/move-rebalance-orders',
      body: MoveRebalanceOrdersInputSchema,
      responses: {
        202: MoveRebalanceOrdersAsyncStartResponseSchema,
      },
    },
    getInflatedCart: {
      method: 'POST',
      path: '/workflows/get-inflated-cart',
      body: z.object({
        cartId: z.string().uuid(),
        postcode: z.string(),
        workflowId: z.string().optional(),
        brand: z.nativeEnum(Brand),
      }),
      responses: {
        200: c.type<InflatedCartDto>(),
      },
    },
    applyPromotionToCart: {
      method: 'POST',
      path: '/workflows/apply-promotion-to-cart',
      body: ApplyPromotionToCartInputSchema,
      responses: {
        200: ApplyPromotionToCartResultSchema,
      },
    },
    lykaCheckout: {
      method: 'POST',
      path: '/workflows/lykaCheckout',
      body: LykaCheckoutInputSchema,
      responses: {
        200: LykaCheckoutResultSchema,
      },
    },
    tygaCheckout: {
      method: 'POST',
      path: '/workflows/tygaCheckout',
      body: TygaCheckoutInputSchema,
      responses: {
        200: TygaCheckoutResultSchema,
      },
    },
    generateOrders: {
      method: 'POST',
      path: '/workflows/generate-orders',
      body: GenerateFutureOrderInputSchema,
      description: 'Generate future orders for a subscription from a given date',
      responses: {
        200: z.array(OrderResponseSchema),
      },
    },
    restructureOrders: {
      method: 'POST',
      path: '/workflows/restructure-orders',
      description: 'Restructure pending orders (lineItems, price, dates) for a subscription and keeping oneOff items in orders',
      body: RestructureOrdersInputSchema,
      responses: {
        200: z.array(OrderResponseSchema),
      },
    },
    retryManifestUpload: {
      method: 'POST',
      path: '/workflows/retry-manifest-upload',
      body: z.object({
        shipmentId: z.string(),
      }),
      responses: {
        200: z.object({
          status: z.string(),
          trackingNumber: z.string(),
          patchedJobs: z.array(z.number()),
        }),
      },
    },
    adminManifestOverride: {
      method: 'POST',
      path: '/workflows/admin-manifest-override',
      body: z.object({
        orderId: z.string().uuid(),
        workflowId: z.string().optional(),
      }),
      responses: {
        200: z.object({
          orderId: z.string().uuid(),
          outcome: z.enum(['manifest_cancelled', 'no_shipment', 'cancel_failed']),
          message: z.string().optional(),
        }),
      },
    },
    sendOrderPaidToFulfilment: {
      method: 'POST',
      path: '/workflows/order-paid-fulfilment',
      body: z.object({
        orderId: z.string().uuid(),
      }),
      responses: {
        200: z.object({
          status: z.string(),
        }),
      },
    },
    refreshMealPlanSnapshotForCustomer: {
      method: 'POST',
      path: '/workflows/refresh-meal-plan-snapshot',
      body: z.object({
        customerId: z.string().uuid(),
      }),
      responses: {
        200: z.object({
          status: z.string(),
        }),
      },
    },
    updateOrderPaidToFulfilment: {
      method: 'POST',
      path: '/workflows/order-updated-fulfilment',
      body: PostPaymentOrderModifiedSchema,
      responses: {
        200: z.object({
          status: z.string(),
        }),
      },
    },
    updateDefaultAddress: {
      method: 'POST',
      path: '/workflows/update-default-address',
      body: z.object({
        subscriptionId: z.string().uuid(),
        workflowId: z.string().optional(),
        date: z.object({
          deliveryDate: z.string(),
          deliverySlot: z.nativeEnum(DeliverySlotWindow),
        }).optional(),
        address: AddressInputSchema,
      }),
      responses: {
        200: z.array(OrderResponseSchema),
      },
    },
    addDogToSubscriptionPreview: {
      method: 'POST',
      path: '/workflows/add-dog-to-subscription-preview',
      body: AddDogToSubscriptionInputSchema,
      responses: {
        200: AddDogToSubscriptionPreviewOutputSchema,
      },
    },
    addDogToSubscription: {
      method: 'POST',
      path: '/workflows/add-dog-to-subscription',
      body: AddDogToSubscriptionInputSchema,
      responses: {
        200: AddDogToSubscriptionOutputSchema,
      },
    },
    addCatToSubscriptionPreview: {
      method: 'POST',
      path: '/workflows/add-cat-to-subscription-preview',
      body: AddCatToSubscriptionInputSchema,
      responses: {
        200: AddCatToSubscriptionPreviewOutputSchema,
      },
    },
    addCatToSubscription: {
      method: 'POST',
      path: '/workflows/add-cat-to-subscription',
      body: AddCatToSubscriptionInputSchema,
      responses: {
        200: UpdateCatSubscriptionPlanOutputSchema,
      },
    },
    removeDogFromSubscriptionPreview: {
      method: 'POST',
      path: '/workflows/remove-dog-from-subscription-preview',
      body: RemoveDogFromSubscriptionInputSchema,
      responses: {
        200: RemoveDogFromSubscriptionPreviewOutputSchema,
      },
    },
    removeDogFromSubscription: {
      method: 'POST',
      path: '/workflows/remove-dog-from-subscription',
      body: RemoveDogFromSubscriptionInputSchema,
      responses: {
        200: RemoveDogFromSubscriptionOutputSchema,
      },
    },
    removeCatFromSubscriptionPreview: {
      method: 'POST',
      path: '/workflows/remove-cat-from-subscription-preview',
      body: RemoveCatFromSubscriptionInputSchema,
      responses: {
        200: RemoveCatFromSubscriptionPreviewOutputSchema,
      },
    },
    removeCatFromSubscription: {
      method: 'POST',
      path: '/workflows/remove-cat-from-subscription',
      body: RemoveCatFromSubscriptionInputSchema,
      responses: {
        200: RemoveCatFromSubscriptionOutputSchema,
      },
    },
    reactivateDogFromSubscriptionPreview: {
      method: 'POST',
      path: '/workflows/reactivate-dog-from-subscription-preview',
      body: ReactivateDogFromSubscriptionInputSchema,
      responses: {
        200: ReactivateDogFromSubscriptionPreviewOutputSchema,
      },
    },
    reactivateDogFromSubscription: {
      method: 'POST',
      path: '/workflows/reactivate-dog-from-subscription',
      body: ReactivateDogFromSubscriptionInputSchema,
      responses: {
        200: ReactivateDogFromSubscriptionOutputSchema,
      },
    },
  },
  options,
)

export const orchestrationRoutesB = c.router(
  {
    reactivateCatFromSubscriptionPreview: {
      method: 'POST',
      path: '/workflows/reactivate-cat-from-subscription-preview',
      body: ReactivateCatFromSubscriptionInputSchema,
      responses: {
        200: ReactivateCatFromSubscriptionPreviewOutputSchema,
      },
    },
    reactivateCatFromSubscription: {
      method: 'POST',
      path: '/workflows/reactivate-cat-from-subscription',
      body: ReactivateCatFromSubscriptionInputSchema,
      responses: {
        200: UpdateCatSubscriptionPlanOutputSchema,
      },
    },
    updateDog: {
      method: 'POST',
      path: '/workflows/update-dog-profile',
      body: z.object({
        workflowId: z.string().optional(),
        dogId: z.string().uuid(),
        dogProfileInput: UpdateDogProfileInputSchema,
      }),
      responses: {
        200: UpdateDogProfileResultSchema,
      },
    },
    updateCat: {
      method: 'POST',
      path: '/workflows/update-cat-profile',
      body: z.object({
        workflowId: z.string().optional(),
        catId: z.string().uuid(),
        catProfileInput: UpdateCatBodySchema,
      }),
      responses: {
        200: CatDtoSchema,
      },
    },
    updateCustomerPaymentMethod: {
      method: 'POST',
      path: '/workflows/update-customer-payment-method',
      body: z.object({
        paymentMethodId: z.string(),
        userId: z.string().uuid(),
        provider: z.string(),
        workflowId: z.string().optional(),
      }),
      responses: {
        200: c.type<CustomerEntity>(),
      },
    },
    getFeedingPlanPricing: {
      method: 'POST',
      path: '/workflows/get-feeding-plan-pricing',
      body: PricedAnimalPlanInputSchema,
      responses: {
        200: PricedAnimalPlanSchema.array(),
      },
    },
    updateOrderDeliveryInfo: {
      method: 'POST',
      path: '/workflows/update-order-delivery-info',
      body: z.object({
        workflowId: z.string().optional(),
        orderId: z.string().uuid(),
        postcode: z.string(),
        suburb: z.string(),
        date: z.object({
          deliverySlotId: z.nativeEnum(DeliverySlotWindow),
          deliveryDate: z.string(),
        }).optional(),
        address: z.object({
          firstName: z.string(),
          lastName: z.string(),
          companyName: z.string().optional(),
          addressId: z.string().uuid(),
          address1: z.string(),
          address2: z.string(),
          city: z.string(),
          state: z.nativeEnum(AddressState),
          countryCode: z.string(),
          deliveryInstructions: z.string().optional(),
        }).optional(),
        applyToFutureOrders: z.boolean().default(true),
        // CCA-only: cascades the delivery date/slot to future orders (via `applyToFutureOrders`)
        // without cascading `address` to them, even when `address` is present in the same
        // request — the address change applies only to `orderId` itself (R2-5222). Tyga/CA never
        // set this, so their existing "address cascades to every future order" behavior is
        // unaffected.
        changeDeliveryDateOnly: z.boolean().optional(),
        chargeNow: z.boolean().optional().default(false),
        deliveryContactNumber: z.string().optional().nullable(),
        // (CA) Account-only: the delay-delivery quick action (R2-5267). When set alongside
        // `applyToFutureOrders`, future orders shift by this many weeks from their own existing
        // delivery date, instead of being renormalized to the subscription's cadence from the
        // new anchor date — preserves any pre-existing irregular spacing between them.
        delayWeeks: z.number().int().positive().optional(),
      }),
      responses: {
        200: OrderResponseSchema,
        400: ErrorResponseSchema,
      },
    },
    deleteFulfilmentOrder: {
      method: 'POST',
      path: '/workflows/delete-fulfilment',
      body: z.object({
        orderId: z.string().uuid(),
        status: z.nativeEnum(JobStatus),
        workflowId: z.string().optional(),
      }),
      responses: {
        200: GetBoxesByOrderResponseSchema.array(),
        400: ErrorResponseSchema,
      },
    },
    cancelOrderFulfilment: {
      method: 'POST',
      path: '/workflows/order-cancelled-fulfilment',
      body: z.object({
        orderId: z.string().uuid(),
      }),
      responses: {
        200: z.object({
          status: z.enum(['Ok', 'Error']),
          message: z.string(),
          orderId: z.string(),
          cancelledJobs: z.array(z.number()).optional(),
        }),
        400: ErrorResponseSchema,
      },
    },
    cancelOrderWithRefund: {
      method: 'POST',
      path: '/workflows/cancel-order-with-refund',
      body: z.object({
        orderId: z.string().uuid(),
      }),
      responses: {
        200: z.object({
          status: z.enum(['Ok', 'Error']),
          message: z.string(),
          orderId: z.string(),
          refundIds: z.array(z.string()).optional(),
        }),
        400: ErrorResponseSchema,
      },
    },
    toggleOrderHold: {
      method: 'POST',
      path: '/workflows/toggle-order-hold',
      body: z.object({
        orderId: z.string().uuid(),
        onHold: z.boolean(),
      }),
      responses: {
        200: z.object({
          status: z.enum(['Ok', 'Error']),
          message: z.string(),
          orderId: z.string(),
        }),
        400: ErrorResponseSchema,
      },
    },
    cancelSubscription: {
      method: 'POST',
      path: '/workflows/cancel-subscription',
      body: CancelSubscriptionInputSchema,
      responses: {
        200: CancelSubscriptionResultSchema,
        400: ErrorResponseSchema,
      },
    },
    pauseSubscription: {
      method: 'POST',
      path: '/workflows/pause-subscription',
      body: PauseSubscriptionInputSchema,
      responses: {
        200: PauseSubscriptionResultSchema,
        400: ErrorResponseSchema,
      },
    },
    addAnimalToSubscription: {
      method: 'POST',
      path: '/workflows/add-animal-to-subscription',
      body: AddAnimalToSubscriptionInputSchema,
      responses: {
        200: AddAnimalToSubscriptionResultSchema,
        400: ErrorResponseSchema,
      },
    },
    manualChargeOrder: {
      method: 'POST',
      path: '/workflows/manual-charge-order',
      body: ManualChargeOrderInputSchema,
      responses: {
        200: ManualChargeOrderResultSchema,
        400: ErrorResponseSchema,
      },
    },
    createTestAccount: {
      method: 'POST',
      path: '/workflows/create-test-account',
      body: CreateTestAccountInputSchema,
      responses: {
        200: CreateTestAccountResultSchema,
        400: ErrorResponseSchema,
      },
    },
    createAccountScenario: {
      method: 'POST',
      path: '/workflows/create-account-scenario',
      body: CreateAccountScenarioInputSchema,
      responses: {
        200: CreateTestAccountResultSchema,
        400: ErrorResponseSchema,
      },
      description: `Creates a test account based on predefined scenarios:\n
        - delivery-soon
        - delivery-today
        - delivery-recent
        - delivery-past
        - payment-today
        - payment-soon
        - payment-failed
        - subscription-cancelled
        - subscription-paused
        - with-removed-pet
      `,
    },
    createTygaTestAccount: {
      method: 'POST',
      path: '/workflows/create-tyga-test-account',
      body: CreateTygaTestAccountInputSchema,
      responses: {
        200: CreateTestAccountResultSchema,
        400: ErrorResponseSchema,
      },
    },
    createTygaAccountForExistingUser: {
      method: 'POST',
      path: '/workflows/create-tyga-account-for-existing-user',
      body: CreateTygaAccountForExistingUserInputSchema,
      responses: {
        200: CreateTestAccountResultSchema,
        400: ErrorResponseSchema,
      },
    },
    addSubscriptionExtra: {
      method: 'POST',
      path: '/workflows/add-subscription-extra',
      body: AddSubscriptionExtraInputSchema,
      responses: {
        200: OrderResponseSchema.array(),
      },
    },
    deleteSubscriptionExtra: {
      method: 'POST',
      path: '/workflows/delete-subscription-extra',
      body: DeleteSubscriptionExtraInputSchema,
      responses: {
        200: OrderResponseSchema.array(),
      },
    },
    updateSubscriptionExtra: {
      method: 'POST',
      path: '/workflows/update-subscription-extra',
      body: UpdateSubscriptionExtraInputSchema,
      responses: {
        200: OrderResponseSchema.array(),
      },
    },
    moveSubscriptionExtra: {
      method: 'POST',
      path: '/workflows/move-subscription-extra',
      body: MoveSubscriptionExtraInputSchema,
      responses: {
        200: OrderResponseSchema.array(),
      },
    },
    addOneOffExtras: {
      method: 'POST',
      path: '/workflows/add-one-off-extra',
      body: AddOneOffExtraInputSchema,
      responses: {
        200: OrderResponseSchema,
      },
    },
    deleteOneOffExtra: {
      method: 'POST',
      path: '/workflows/delete-one-off-extra',
      body: DeleteOneOffExtraInputSchema,
      responses: {
        200: OrderResponseSchema,
      },
    },
    updateOneOffExtra: {
      method: 'POST',
      path: '/workflows/update-one-off-extra',
      body: UpdateOneOffExtraInputSchema,
      responses: {
        200: OrderResponseSchema,
      },
    },
    updateOrderExtrasPreview: {
      method: 'POST',
      path: '/workflows/update-order-extras-preview',
      body: UpdateOrderExtrasPreviewInputSchema,
      responses: {
        200: UpdateOrderExtrasPreviewOutputSchema,
      },
    },
    getOrderAllowedFreePouchVariants: {
      method: 'POST',
      path: '/workflows/get-order-allowed-free-pouch-variants',
      summary: 'Returns the meal variants a free pouch can be added at for an order',
      description: 'Filters the meal catalog to pouch sizes already on the order\'s plan meals. Multi-dog orders return the union of sizes (e.g. 500g + 400g).',
      body: GetOrderAllowedFreePouchVariantsInputSchema,
      responses: {
        200: GetOrderAllowedFreePouchVariantsOutputSchema,
      },
    },
    migrateDataFromLaravelToPhoenix: {
      method: 'POST',
      path: '/workflows/migrate',
      query: MigrateDataFromLaravelToPhoenixQuerySchema,
      body: MigrateDataFromLaravelToPhoenixInputSchema,
      responses: {
        200: MigrateDataFromLaravelToPhoenixOutputSchema,
      },
    },
    bulkMigrateDataFromLaravelToPhoenix: {
      method: 'POST',
      path: '/workflows/bulk-migrate',
      query: MigrateDataFromLaravelToPhoenixQuerySchema,
      body: BulkMigrateDataFromLaravelToPhoenixInputSchema,
      responses: {
        200: BulkMigrateDataFromLaravelToPhoenixOutputSchema,
      },
    },
    bulkMigrateDataFromLaravelToPhoenixV2: {
      method: 'POST',
      path: '/workflows/bulk-migrate-v2',
      query: MigrateDataFromLaravelToPhoenixQuerySchema,
      body: BulkMigrateDataFromLaravelToPhoenixV2InputSchema,
      responses: {
        200: BulkMigrateDataFromLaravelToPhoenixOutputSchema,
      },
    },
    migrateUserEventDataFromLaravelToPhoenix: {
      method: 'POST',
      path: '/workflows/migrate-user-event',
      query: MigrateDataFromLaravelToPhoenixQuerySchema,
      body: MigrateUserEventDataFromLaravelToPhoenixInputSchema,
      responses: {
        200: MigrateGeneralOutputSchema,
      },
    },
    migrateHistoryDataFromLaravelToPhoenix: {
      method: 'POST',
      path: '/workflows/migrate-history',
      query: MigrateDataFromLaravelToPhoenixQuerySchema,
      body: MigrateHistoryDataFromLaravelToPhoenixInputSchema,
      responses: {
        200: MigrateHistoryDataFromLaravelToPhoenixOutputSchema,
      },
    },
    bulkMigrateUserEventDataFromLaravelToPhoenix: {
      method: 'POST',
      path: '/workflows/bulk-migrate-user-events',
      query: MigrateDataFromLaravelToPhoenixQuerySchema,
      body: BulkMigrateUserEventDataFromLaravelToPhoenixInputSchema,
      responses: {
        200: BulkMigrateDataFromLaravelToPhoenixOutputSchema,
      },
    },
    bulkMigrateHistoryDataFromLaravelToPhoenix: {
      method: 'POST',
      path: '/workflows/bulk-migrate-history',
      query: MigrateDataFromLaravelToPhoenixQuerySchema,
      body: BulkMigrateHistoryDataFromLaravelToPhoenixInputSchema,
      responses: {
        200: BulkMigrateDataFromLaravelToPhoenixOutputSchema,
      },
    },
    backfillFeedingPlanHistoryIds: {
      method: 'POST',
      path: '/workflows/backfill-feeding-plan-history-ids',
      query: MigrateDataFromLaravelToPhoenixQuerySchema,
      body: BackfillFeedingPlanHistoryIdsInputSchema,
      responses: {
        200: BackfillFeedingPlanHistoryIdsOutputSchema,
      },
    },
    revertMigratedData: {
      method: 'POST',
      path: '/workflows/revert-migrate',
      query: MigrateDataFromLaravelToPhoenixQuerySchema,
      body: MigrateDataFromLaravelToPhoenixInputSchema.omit({ dryRun: true }).extend({
        selectedHistoryTables: z.nativeEnum(HistoryTables).array().default(Object.values(HistoryTables)).describe('Subset of history tables to migrate. Defaults to all implemented tables.'),
        onlyRevertHistoryData: z.boolean().default(false).describe('If true, only reverts history data without affecting core data.'),
      }),
      responses: {
        200: MigrateDataFromLaravelToPhoenixOutputSchema,
      },
    },
    bulkRevertMigratedData: {
      method: 'POST',
      path: '/workflows/bulk-revert-migrate',
      query: MigrateDataFromLaravelToPhoenixQuerySchema,
      body: BulkMigrateDataFromLaravelToPhoenixInputSchema.omit({ dryRun: true }).extend({
        selectedHistoryTables: z.nativeEnum(HistoryTables).array().default(Object.values(HistoryTables)).describe('Subset of history tables to migrate. Defaults to all implemented tables.'),
        onlyRevertHistoryData: z.boolean().default(false).describe('If true, only reverts history data without affecting core data.'),
      }),
      responses: {
        200: BulkMigrateDataFromLaravelToPhoenixOutputSchema,
      },
    },
    revertMigratedUserEventData: {
      method: 'POST',
      path: '/workflows/revert-migrate-user-event',
      query: MigrateDataFromLaravelToPhoenixQuerySchema,
      body: RevertMigrateUserEventSchema,
      responses: {
        200: MigrateGeneralOutputSchema,
      },
    },
    verifyMigratedData: {
      method: 'POST',
      path: '/workflows/verify-migrate',
      query: MigrateDataFromLaravelToPhoenixQuerySchema,
      body: MigrateDataFromLaravelToPhoenixInputSchema.omit({ dryRun: true }),
      responses: {
        200: VerificationResponseSchema,
      },
    },
    applySubscriptionDiscount: {
      method: 'POST',
      path: '/workflows/apply-subscription-discount',
      body: ApplySubscriptionDiscountInput,
      responses: {
        200: ApplySubscriptionDiscountResult,
      },
    },
    applySubscriptionDiscountPreview: {
      method: 'POST',
      path: '/workflows/apply-subscription-discount-preview',
      body: ApplySubscriptionDiscountPreviewInputSchema,
      responses: {
        200: ApplySubscriptionDiscountPreviewResultSchema,
      },
    },
    removeSubscriptionDiscount: {
      method: 'POST',
      path: '/workflows/remove-subscription-discount',
      body: RemoveSubscriptionDiscountInputSchema,
      responses: {
        200: RemoveSubscriptionDiscountResultSchema,
      },
    },
    applyOrderDiscount: {
      method: 'POST',
      path: '/workflows/apply-order-discount',
      body: ApplyOrderDiscountInputSchema,
      responses: {
        200: ApplyOrderDiscountOutputSchema,
      },
    },
    applyOrderDiscountPreview: {
      method: 'POST',
      path: '/workflows/apply-order-discount-preview',
      body: ApplyOrderDiscountPreviewInputSchema,
      responses: {
        200: ApplyOrderDiscountPreviewOutputSchema,
      },
    },
    removeOrderDiscount: {
      method: 'POST',
      path: '/workflows/remove-order-discount',
      body: RemoveOrderDiscountInputSchema,
      responses: {
        200: RemoveOrderDiscountOutputSchema,
      },
    },
    deleteOrderComplaint: {
      method: 'POST',
      path: '/workflows/delete-order-complaint',
      body: DeleteOrderComplaintInputSchema,
      responses: {
        200: DeleteOrderComplaintOutputSchema,
      },
    },
    createOrderComplaint: {
      method: 'POST',
      path: '/workflows/create-order-complaint',
      body: CreateOrderComplaintWorkflowInputSchema,
      responses: {
        200: CreateOrderComplaintWorkflowOutputSchema,
      },
    },
    updateOrderComplaint: {
      method: 'POST',
      path: '/workflows/update-order-complaint',
      body: UpdateOrderComplaintWorkflowInputSchema,
      responses: {
        200: UpdateOrderComplaintWorkflowOutputSchema,
      },
    },
    applyReferrerReward: {
      method: 'POST',
      path: '/workflows/apply-referrer-reward',
      body: ApplyReferrerRewardInputSchema,
      responses: {
        200: ApplyReferrerRewardOutputSchema,
      },
    },
    reactivateSubscription: {
      method: 'POST',
      path: '/workflows/reactivate-subscription',
      body: ReactivateSubscriptionInputSchema,
      responses: {
        200: SubscriptionSchema,
      },
    },
    resumeSubscription: {
      method: 'POST',
      path: '/workflows/resume-subscription',
      body: ResumeSubscriptionInputSchema,
      responses: {
        200: SubscriptionSchema,
      },
    },
    verifySubscriptionOrders: {
      method: 'POST',
      path: '/workflows/verify-subscription-orders',
      body: VerifySubscriptionOrdersSchema,
      responses: {
        200: VerificationResponseSchema,
      },
    },
    recalculateDogMealPlanSubscription: {
      method: 'POST',
      path: '/workflows/recalculate-dog-meal-plan-subscription',
      body: RecalculateDogMealPlanSubscriptionInputSchema,
      responses: {
        200: RecalculateDogMealPlanSubscriptionOutputSchema,
      },
    },
    updateDogSubscriptionActiveFeedingPlansPreview: {
      method: 'POST',
      path: '/workflows/update-dog-subscription-active-feeding-plans-preview',
      body: UpdateDogSubscriptionActiveFeedingPlansInputSchema,
      responses: {
        200: UpdateDogSubscriptionActiveFeedingPlansPreviewOutputSchema,
      },
    },
    updateDogSubscriptionActiveFeedingPlans: {
      method: 'POST',
      path: '/workflows/update-dog-subscription-active-feeding-plans',
      body: UpdateDogSubscriptionActiveFeedingPlansInputSchema,
      responses: {
        200: UpdateDogSubscriptionActiveFeedingPlansOutputSchema,
      },
    },
    updateCatSubscriptionPlanPreview: {
      method: 'POST',
      path: '/workflows/update-cat-subscription-plan-preview',
      body: UpdateCatSubscriptionPlanInputSchema,
      responses: {
        200: UpdateCatSubscriptionPlanPreviewOutputSchema,
      },
    },
    updateCatSubscriptionPlan: {
      method: 'POST',
      path: '/workflows/update-cat-subscription-plan',
      body: UpdateCatSubscriptionPlanInputSchema,
      responses: {
        200: UpdateCatSubscriptionPlanOutputSchema,
      },
    },
    updateSubscriptionExtrasPreview: {
      method: 'POST',
      path: '/workflows/update-subscription-extras-preview',
      body: UpdateSubscriptionExtrasInputSchema,
      responses: {
        200: UpdateSubscriptionExtrasPreviewOutputSchema,
      },
    },
    updateSubscriptionExtras: {
      method: 'POST',
      path: '/workflows/update-subscription-extras',
      body: UpdateSubscriptionExtrasInputSchema,
      responses: {
        200: UpdateSubscriptionExtrasOutputSchema,
      },
    },
    reconcilePhoenixToggle: {
      method: 'POST',
      path: '/workflows/reconcile-phoenix-toggle',
      body: ReconcilePhoenixToggleInputSchema,
      responses: {
        200: ReconcilePhoenixToggleOutputSchema,
        400: ErrorResponseSchema,
      },
    },
    netsuiteSyncSummary: {
      method: 'POST',
      path: '/workflows/netsuite-sync-summary',
      summary: 'Run the NetSuite sync digest for one calendar day and post it to the netsuite-alerts Slack channel',
      description: 'Compares what should have synced to NetSuite (orders paid that day with netsuite_outbox_toggle on, plus toggled orders palletised or delivered that day or the day before) against the outbox rows emitted and the NetSuite ids recorded, all from the order DB — no NetSuite call. Catches the classes per-row failure alerting cannot: an order that never produced an outbox row, a row retrying silently for hours, the all-days FAILED/BLOCKED backlog, and NetSuite records against a failed charge. isDailyReport always posts; otherwise it posts only when something needs attention.',
      body: NetsuiteSyncSummaryInputSchema,
      responses: {
        200: NetsuiteSyncSummaryOutputSchema,
        400: ErrorResponseSchema,
      },
    },
    backfillOrderLineItemProductType: {
      method: 'POST',
      path: '/workflows/backfill-order-line-item-product-type',
      body: BackfillOrderLineItemProductTypeInputSchema,
      responses: {
        200: BackfillOrderLineItemProductTypeOutputSchema,
      },
    },
    backfillOrderAnimalServings: {
      method: 'POST',
      path: '/workflows/backfill-order-animal-servings',
      summary: 'Backfill per-animal daily serving sizes (order_animal_servings.daily_serving_size_in_grams) on all Lyka orders of Phoenix customers',
      description: 'Pages the lyka_phoenix_customer cohort by cursor, groups each page by user, and fans out a per-user child workflow that reconstructs each order\'s animal servings from its meal line items + product pouch weights and upserts them. Tyga is excluded. Pass a userId to run/verify a single customer. Supports dryRun.',
      body: BackfillOrderAnimalServingsInputSchema,
      responses: {
        200: BackfillOrderAnimalServingsOutputSchema,
      },
    },
    backfillOrderPricing: {
      method: 'POST',
      path: '/workflows/backfill-order-pricing',
      summary: 'Backfill pricing fields (unitPrice/unitChargePrice/totalPrice/totalCharge + applied discount ids + plan totals) on Tyga or Phoenix-generated Lyka orders',
      description: 'Pages the chosen cohort by cursor, fans out a per-user child workflow that reprices each order via the pricing service and writes the new pricing fields. Charged totals are preserved. Supports dryRun.',
      body: BackfillOrderPricingInputSchema,
      responses: {
        200: BackfillOrderPricingOutputSchema,
      },
    },
    backfillOrderSubscriptionHistory: {
      method: 'POST',
      path: '/workflows/backfill-order-subscription-history',
      summary: 'Backfill subscription_history_id on Tyga or Phoenix-generated Lyka orders by matching billed date against subscription history snapshots',
      description: 'Pages the chosen cohort by cursor, groups each page by subscription, and fans out a per-subscription child workflow that resolves each order to the subscriptions_history snapshot active when it was billed (falling back to subscriptionId). Supports dryRun.',
      body: BackfillOrderSubscriptionHistoryInputSchema,
      responses: {
        200: BackfillOrderSubscriptionHistoryOutputSchema,
      },
    },
    consolidateMigratedOrderSubscriptions: {
      method: 'POST',
      path: '/workflows/consolidate-migrated-order-subscriptions',
      summary: 'Consolidate migrated Lyka orders onto the active subscription: port subscription_id → subscription_history_id, re-point to the live subscription, and re-sequence subscription_order_index',
      description: 'Pages migrated (order_id_mapping) phoenix-toggle Lyka orders by cursor, groups by user, resolves each user\'s live subscription, then moves + re-indexes their orders. Supports dryRun.',
      body: ConsolidateMigratedOrderSubscriptionsInputSchema,
      responses: {
        200: ConsolidateMigratedOrderSubscriptionsOutputSchema,
      },
    },
    consolidatePhoenixOrderSubscriptions: {
      method: 'POST',
      path: '/workflows/consolidate-phoenix-order-subscriptions',
      summary: 'Consolidate ALL phoenix-toggle Lyka orders (migrated + native) onto the active subscription and re-sequence subscription_order_index (leaves subscription_history_id untouched)',
      description: 'Pages distinct phoenix-toggle customers, resolves each user\'s active (latest) Lyka subscription, then moves ALL their Lyka orders onto it and re-indexes. Supports dryRun and a single userId canary.',
      body: ConsolidatePhoenixOrderSubscriptionsInputSchema,
      responses: {
        200: ConsolidatePhoenixOrderSubscriptionsOutputSchema,
      },
    },
    backfillOrderCutoffs: {
      method: 'POST',
      path: '/workflows/backfill-order-cutoffs',
      summary: 'Backfill order_cutoffs by calling resolve per eligible order',
      description: 'Pages orders eligible for cutoff resolve (soonest delivery_date first) and POSTs /orders/:orderId/cutoffs/resolve with bounded concurrency. By default only orders without a cache row; pass includeNonProcessed=true to also re-resolve non-processed orders with existing rows.',
      body: BackfillOrderCutoffsInputSchema,
      responses: {
        200: BackfillOrderCutoffsOutputSchema,
      },
    },
    backfillStarterBox: {
      method: 'POST',
      path: '/workflows/backfill-starter-box',
      description: 'Backfill starter box / trial box feeding plans in the feeding_plans table',
      body: BackfillStarterBoxFeedingPlanInputSchema,
      responses: {
        200: BackfillStarterBoxFeedingPlanOutputSchema
      },
    },
    repairOrderUserIds: {
      method: 'POST',
      path: '/workflows/repair-order-user-ids',
      summary: 'Repair Phoenix orders that carry the wrong user id, using Laravel as the authority on the owner',
      description: 'Fix the userId in orders.',
      body: RepairOrderUserIdsInputSchema,
      responses: {
        200: RepairOrderUserIdsOutputSchema,
      },
    },
    backfillMealPlanSnapshots: {
      method: 'POST',
      path: '/workflows/backfill-meal-plan-snapshots',
      summary: 'Backfill meal plan snapshots on fulfilments for paid Phoenix orders (OPS-3222)',
      description: 'Pages paid, Phoenix, not-yet-started orders and reuses the idempotent per-order refresh activity to rebuild the meal plan snapshot on each order\'s active fulfilments. Phoenix = migrated (customer_flags.phoenix_toggle true) OR genuine native (no customer_flags row AND no legacy order_id_mapping); legacy un-migrated CDC-mirrored orders are excluded. Repairs both missing snapshots (phoenix_toggle race) and snapshots built with an empty recipes array. Started/no-active fulfilments are skipped by the same guard the box-contents-update path uses.',
      body: BackfillMealPlanSnapshotsInputSchema,
      responses: {
        200: BackfillMealPlanSnapshotsOutputSchema,
      },
    },
    backfillFulfilmentCustomerIds: {
      method: 'POST',
      path: '/workflows/backfill-fulfilment-customer-ids',
      summary: 'Backfill fulfilments.customer_id from orders.user_id (OPS-3212)',
      description: 'Pages fulfilments joined to jobs.order_id and patches rows where customer_id still carries the delivery address id. Idempotent — rows already matching orders.user_id are counted as already_correct. Pass resumeCursor from a failed run\'s progress query to continue on a new POST.',
      body: BackfillFulfilmentCustomerIdsInputSchema,
      responses: {
        200: BackfillFulfilmentCustomerIdsOutputSchema,
      },
    },
    rescheduleBlockedOrders: {
      method: 'POST',
      path: '/workflows/reschedule-blocked-orders',
      summary: 'Reschedule orders affected by operational blocks',
      description:
        'Bulk-reschedules Phoenix orders on blocked dates using the smart-shift cohort decision tree (extended/conservative search, standard PH surcharge skip, impossible PH flag). Provide exactly one of blockedDates or operationalBlockId; optionally narrow with brands (e.g. lyka only), userIds, or orderIds (fetch-time scope and blocked-date validation). Supports dry-run preview via wouldReschedule counters.',
      body: RescheduleBlockedOrdersInputSchema,
      responses: {
        200: RescheduleBlockedOrdersOutputSchema,
      },
    },
    duplicateOrder: {
      method: 'POST',
      path: '/workflows/duplicate-order',
      summary: 'Duplicate a paid order as a free replacement (admin / CC only)',
      description:
        'Clones a paid source order into a new $0 replacement order on the requested delivery date. Logs a user event on the original order, notifies Slack, and optionally shifts the subscription\'s upcoming orders forward.',
      body: DuplicateOrderInputSchema,
      responses: {
        200: DuplicateOrderOutputSchema,
      },
    },
    seedFulfilmentData: {
      method: 'POST',
      path: '/workflows/seed-fulfilment-data',
      summary: 'Seed fulfilment data for box tracker load testing',
      description: 'Creates N orders for a given user, runs them through the fulfilment pipeline (paid → packed → palletised → delivered), with configurable percentages at each stage.',
      body: SeedFulfilmentDataInputSchema,
      responses: {
        200: SeedFulfilmentDataOutputSchema,
      },
    },
    launchRafCampaign: {
      method: 'POST',
      path: '/workflows/launch-raf-campaign',
      summary: 'Put a refer-a-friend campaign live: create it, close the outgoing one, move the coupons',
      description:
        `The whole changeover in one run. Validates everything first, then closes whichever campaign covers the start date and opens this one in a single transaction, then points existing referral coupons at its referee discount so they earn the new perks. The coupon move runs in bounded batches so a brand with hundreds of thousands of coupons completes inside the workflow's 2-hour execution timeout rather than timing out on a single multi-minute HTTP call. Both discounts must already exist in pricing — create them there first and pass their ids. Perks are given as SKUs and resolved against this environment, so the same payload works everywhere. Safe to re-run: a second run reports zero coupons moved and changes nothing, which is also how a partial failure is recovered — the campaign upsert is a no-op and the repoint resumes wherever it stopped because already-moved coupons fall out of the selection. Always run with dryRun first — it reports the discounts' real percentages, every SKU's product name, and the coupon count, without writing anything.`,
      body: LaunchRafCampaignInputSchema,
      responses: {
        200: LaunchRafCampaignOutputSchema,
      },
    },
    bulkMigrateRafCoupons: {
      method: 'POST',
      path: '/workflows/bulk-migrate-raf-coupons',
      summary: 'Bulk migrate Laravel refer_coupons rows into Phoenix promotions (REFERRAL_COUPON)',
      query: MigrateDataFromLaravelToPhoenixQuerySchema,
      body: BulkMigrateRafCouponsInputSchema,
      responses: {
        200: BulkMigrateRafCouponsOutputSchema,
      },
    },
    bulkMigrateRafCouponUsers: {
      method: 'POST',
      path: '/workflows/bulk-migrate-raf-coupon-users',
      summary: 'Bulk migrate Laravel refer_coupons_users rows into Phoenix promotion_users',
      query: MigrateDataFromLaravelToPhoenixQuerySchema,
      body: BulkMigrateRafCouponUsersInputSchema,
      responses: {
        200: BulkMigrateRafCouponUsersOutputSchema,
      },
    },
    migrateBaBCustomerFromLaravelToPhoenix: {
      method: 'POST',
      path: '/workflows/migrate-bab-customer-from-laravel-to-phoenix',
      summary: 'Trigger post-BaB-checkout customer migration from Laravel to Phoenix',
      query: MigrateDataFromLaravelToPhoenixQuerySchema,
      body: MigrateBaBCustomerFromLaravelToPhoenixInputSchema,
      responses: {
        200: MigrateBaBCustomerFromLaravelToPhoenixOutputSchema,
        400: ErrorResponseSchema,
        500: ErrorResponseSchema,
      },
    },
    upsertNetsuiteCustomer: {
      method: 'POST',
      path: '/workflows/netsuite/customers/upsert',
      summary: 'Upsert a Phoenix customer into NetSuite (lookup → create → write back)',
      description:
        'Resolves the NetSuite customer id for a Phoenix customer. Returns the existing id from customer_flags if known; otherwise looks NetSuite up by externalId and falls back to creating a new customer record. The returned id is written back to customer_flags so subsequent calls short-circuit on the cached value.',
      body: UpsertNetsuiteCustomerInputSchema,
      responses: {
        200: UpsertNetsuiteCustomerOutputSchema,
        400: ErrorResponseSchema,
        500: ErrorResponseSchema,
      },
    },
  },
  options,
)

export const orchestrationRoutesC = c.router({
  checkCouponExists: {
    method: 'POST',
    path: '/workflows/coupons/exists',
    summary: 'Check whether a coupon exists for the given brand/value',
    body: CheckCouponExistsInputSchema,
    responses: {
      200: CheckCouponExistsOutputSchema,
      400: ErrorResponseSchema,
      500: ErrorResponseSchema,
    },
  },
  updateRafCoupon: {
    method: 'POST',
    path: '/workflows/coupons/raf/update',
    summary: 'Update a RAF coupon for the given user/brand/value',
    body: UpdateRafCouponInputSchema,
    responses: {
      200: UpdateRafCouponOutputSchema,
      400: ErrorResponseSchema,
      500: ErrorResponseSchema,
    },
  },
  getEnrichedUserEvents: {
    method: 'POST',
    path: '/workflows/get-enriched-user-events',
    summary: 'Get user events enriched with actor and animal names',
    description: 'Fetches paginated user events and enriches them with names for actors and animals.',
    body: GetEnrichedUserEventsInputSchema,
    responses: {
      200: GetEnrichedUserEventsOutputSchema,
      400: ErrorResponseSchema,
      500: ErrorResponseSchema,
    },
  },
  getPuppyMilestones: {
    method: 'POST',
    path: '/workflows/get-puppy-milestones',
    summary: 'Get puppy weight milestones with serving sizes',
    description: 'Fetches a puppy recommendation for the dog and converts each milestone meal weight into a serving size.',
    body: GetPuppyMilestonesInputSchema,
    responses: {
      200: GetPuppyMilestonesOutputSchema,
      400: ErrorResponseSchema,
      500: ErrorResponseSchema,
    },
  },
  graduatePuppy: {
    method: 'POST',
    path: '/workflows/graduate-puppy',
    summary: 'Graduate a single puppy to adult',
    description: 'Starts the graduatePuppy workflow which calls the animal service to mark the dog as graduated (lifestage ADULT).',
    body: GraduatePuppyInputSchema,
    responses: {
      200: GraduatePuppyOutputSchema,
      400: ErrorResponseSchema,
      500: ErrorResponseSchema,
    },
  },
  sendPublicHolidayNotifications: {
    method: 'POST',
    path: '/workflows/send-public-holiday-notifications',
    summary: 'Send notification emails for orders rescheduled off a public holiday',
    description: 'Fetches reschedule tracking records for the given operationalBlockId (from the bulk reschedule run), validates each order still has the rescheduled delivery date, and emits a public_holiday_order_rescheduled CIO event per affected order. Optionally pass blockedDate when multiple blocks were processed on the same day. Run after rescheduleBlockedOrders has moved orders.',
    body: SendPublicHolidayNotificationsInputSchema,
    responses: {
      202: SendPublicHolidayNotificationsAsyncStartResponseSchema,
    },
  },
  checkSubscriptionValidity: {
    method: 'POST',
    path: '/workflows/check-subscription-validity',
    summary: 'Check whether a subscription is in a state that can generate orders',
    description: 'Audits a subscription end to end: default address completeness and serviceability, postcode timezone, start date in the future, courier cutoffs resolvable for that start date, an active feeding plan, and every feeding-plan/extra SKU still mapping to an active product variant. Throws a typed non-retryable failure on the first invalid condition. Also remedies lastProcessedOrderIndex when it has drifted from the latest processed order. Pass startDateOverride / deliverySlotOverride to validate a prospective change without writing it.',
    body: CheckSubscriptionValidityInputSchema,
    responses: {
      200: CheckSubscriptionValidityOutputSchema,
      400: ErrorResponseSchema,
      500: ErrorResponseSchema,
    },
  },
  sanitizeSubscription: {
    method: 'POST',
    path: '/workflows/sanitize-subscription',
    summary: 'Sanitize a subscription: for Lyka, redistribute unsupported meal SKUs onto the active ones; for both brands, cancel extras pointing at unavailable variants',
    description: 'Reads the subscription and the brand product catalogue. For Lyka, feeding-plan SKUs whose product or variant is no longer active are removed and their ratios redistributed unit-by-unit onto the remaining active SKUs in meal-preference order (chicken -> kangaroo -> turkey -> beef -> lamb -> goat, unknown meals last); fails non-retryably if no active SKU remains. For both brands, active extras whose product or variant is no longer active are cancelled using the `${brand}:tre-no-stock` cancel reason (treat context). Idempotent: already-cancelled extras are skipped and a subscription with nothing to sanitize is returned untouched.',
    body: SanitizeSubscriptionInputSchema,
    responses: {
      200: SanitizeSubscriptionOutputSchema,
      400: ErrorResponseSchema,
      500: ErrorResponseSchema,
    },
  },
  redistributeSubscriptionMeal: {
    method: 'POST',
    path: '/workflows/redistribute-subscription-meal',
    summary: 'Remove one meal from a Lyka subscription\'s feeding plans and redistribute its pouches onto the remaining meals',
    description: 'Bulk backfill: for each userId, updates Lyka feeding plans where the dog has the given food allergen by removing the named meal and redistributing its pouches. Returns succeeded/skipped user and plan lists; per-user failures are logged and swallowed. Continue-as-new runs automatically when workflow history grows. Non-active subscriptions get a plan-only update (no order restructure). Idempotent.',
    body: RedistributeSubscriptionMealInputSchema,
    responses: {
      200: RedistributeSubscriptionMealOutputSchema,
      400: ErrorResponseSchema,
      500: ErrorResponseSchema,
    },
  },
}, options)

type OrchestrationServiceContract =
  & typeof orchestrationRoutesA
  & typeof orchestrationRoutesB
  & typeof orchestrationRoutesC
  & typeof partnersRoutes

const orchestrationServiceContract: OrchestrationServiceContract = {
  ...orchestrationRoutesA,
  ...orchestrationRoutesB,
  ...orchestrationRoutesC,
  ...partnersRoutes,
}

export default orchestrationServiceContract
export { orchestrationServiceContract }
